import type React from 'react';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteRounded from '@mui/icons-material/DeleteRounded';
import { Button, DialogActions } from '@mui/material';

import ButtonPanel from 'src/components/common/ButtonPanel';
import Modal from 'src/components/common/Modal';
import { WorkspaceContext } from 'src/components/workspace/WorkspaceContext';

interface ClearDatalinesComponentProps {
  clearDatalines: () => false;
}
export const ClearDatalinesComponent: React.FC<
  ClearDatalinesComponentProps
> = ({ clearDatalines }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { t } = useTranslation('workspace');

  /**
   * Open or Close modal
   */
  const openModal = () => {
    setModalIsOpen((prev) => !prev);
  };
  return (
    <Fragment>
      <ButtonPanel onClick={openModal}>
        <DeleteRounded fontSize="large" />

        <span className="clear-datalines-button__label">
          {t('clearWorkspace.button')}
        </span>
      </ButtonPanel>

      <Modal
        headline={t('clearWorkspace.title')}
        isOpen={modalIsOpen}
        message={t('clearWorkspace.message')}
        onClose={openModal}
        icon={<DeleteRounded fontSize="large" />}
      >
        <DialogActions>
          <Button variant="cta" color="secondary" fullWidth onClick={openModal}>
            {t('common:cancel')}
          </Button>

          <Button
            variant="cta"
            fullWidth
            onClick={() => {
              clearDatalines();
              openModal();
            }}
          >
            {t('clearWorkspace.title')}
          </Button>
        </DialogActions>
      </Modal>
    </Fragment>
  );
};

const ClearDatalinesWrapper = (props: any) => (
  <WorkspaceContext.Consumer>
    {(context) =>
      context?.clearDatalines ? (
        <ClearDatalinesComponent
          clearDatalines={context.clearDatalines}
          {...props}
        />
      ) : null
    }
  </WorkspaceContext.Consumer>
);

export default ClearDatalinesWrapper;
